import React, { useState } from "react";
import {
  Grid,
  Typography,
  Tabs,
  Tab,
  Box,
  Stack,
  Button,
  Alert,
} from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { createBlobInContainer } from "src/utils/azureBlob";
import MastersMissionsConfig from "./MastersMissionsConfig";
import MastersMissionsHistory from "./MastersMissionsHistory";

export default function MastersConfig({
  gameConfig,
  setGameConfig,
  loading = false,
  gameProviderId,
}) {
  console.log("MastersConfig gameProviderId:", gameProviderId);
  const [activeTab, setActiveTab] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [logoKey, setLogoKey] = useState(Date.now());

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const uploadLogo = async (event) => {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!file) return;

      const validTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif"];
      const maxSize = 2 * 1024 * 1024;

      if (!validTypes.includes(file.type)) {
        setUploadError("Only JPG, JPEG, PNG, WEBP, and GIF formats are allowed.");
        event.target.value = null;
        return;
      }

      if (file.size > maxSize) {
        setUploadError("File size should not exceed 2MB.");
        event.target.value = null;
        return;
      }

      setUploading(true);
      setUploadError(null);
      setUploadSuccess(false);
      try {
        const extension = file.name.substring(file.name.lastIndexOf("."));
        const fileName = `logo${extension}`;
        const blobName = `gameprovider_${gameProviderId}/${fileName}`;
        const renamedFile = new File([file], blobName, { type: file.type });

        await createBlobInContainer(renamedFile);
        const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
        const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
        const logoUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blobName}`;

        console.log("Logo uploaded:", logoUrl);
        setUploadSuccess(true);
        setLogoKey(Date.now()); // Force logo to reload
        setTimeout(() => setUploadSuccess(false), 3000);
      } catch (err) {
        console.error(err);
        setUploadError("Failed to upload logo");
      } finally {
        setUploading(false);
        event.target.value = null;
      }
    }
  };

  const getLogoUrl = () => {
    if (!gameProviderId) return null;
    const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
    const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
    console.log('getLogoUrl:', `https://${storageAccountName}.blob.core.windows.net/${containerName}/gameprovider_${gameProviderId}/logo.png`);
    return `https://${storageAccountName}.blob.core.windows.net/${containerName}/gameprovider_${gameProviderId}/logo.png?v=${logoKey}`;
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {uploadError && (
          <Alert severity="error" onClose={() => setUploadError(null)} sx={{ mb: 2 }}>
            {uploadError}
          </Alert>
        )}
        {uploadSuccess && (
          <Alert severity="success" onClose={() => setUploadSuccess(false)} sx={{ mb: 2 }}>
            Logo uploaded successfully!
          </Alert>
        )}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h6" gutterBottom>
            Match Masters Configuration
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            {getLogoUrl() && (
              <Box
                component="img"
                src={getLogoUrl()}
                alt="Game Logo"
                sx={{
                  width: 60,
                  height: 60,
                  objectFit: "contain",
                  border: "1px solid #ddd",
                  borderRadius: 1,
                  p: 0.5,
                }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            )}
            <Box>
              <input
                accept="image/*"
                style={{ display: "none" }}
                id="upload-logo"
                type="file"
                onChange={uploadLogo}
                disabled={uploading || !gameProviderId}
              />
              <label htmlFor="upload-logo">
                <Button
                  variant="outlined"
                  component="span"
                  size="small"
                  startIcon={<CloudUpload />}
                  disabled={uploading || !gameProviderId}
                >
                  {uploading ? "Uploading..." : "Upload Logo"}
                </Button>
              </label>
            </Box>
          </Box>
        </Stack>
        <Box sx={{ mb: 1 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="masters tabs"
          >
            <Tab label="Missions Config" />
            <Tab label="Missions History" />
          </Tabs>
        </Box>

        {activeTab === 0 && (
          <MastersMissionsConfig
            gameConfig={gameConfig}
            setGameConfig={setGameConfig}
            loading={loading}
          />
        )}
        {activeTab === 1 && (
          <MastersMissionsHistory
            gameConfig={gameConfig}
            setGameConfig={setGameConfig}
            loading={loading}
          />
        )}
      </Grid>
    </Grid>
  );
}
